document.addEventListener("DOMContentLoaded", function () {
    const categorySelect = document.getElementById("category");
    const dynamicCategoriesContainer = document.getElementById("dynamic-categories");
    const formMessage = document.getElementById("form-message");
    const attachmentsInput = document.getElementById("attachments");
    let uploadTokens = [];

    // Charger les catégories principales
    Object.entries(categoryHierarchy).forEach(([key, category]) => {
        const option = document.createElement("option");
        option.value = category.value;
        option.textContent = category.label;
        categorySelect.appendChild(option);
    });

    categorySelect.addEventListener("change", function () {
        const selectedCategory = categoryHierarchy[categorySelect.value];
        dynamicCategoriesContainer.innerHTML = "";

        if (selectedCategory) {
            createDropdown(selectedCategory, dynamicCategoriesContainer, selectedCategory.label);
        }

        // Vérifier si la catégorie sélectionnée est "Assistance générale"
        toggleOrderNumberRequirement(categorySelect.value);
    });

    function createDropdown(category, container, title) {
        const label = document.createElement("label");
        label.textContent = `${title}`;
        label.classList.add("field__label");

        const dropdown = document.createElement("div");
        dropdown.classList.add("form-group");
        dropdown.classList.add("field");

        const select = document.createElement("select");
        select.dataset.fieldId = category.fieldId;
        select.required = true;
        select.classList.add("form-select");
        select.classList.add("field__input");
        select.innerHTML = `<option value="" disabled selected>Choisissez une option</option>`;

        category.options.forEach(option => {
            const opt = document.createElement("option");
            opt.value = option.value;
            opt.textContent = option.label;
            select.appendChild(opt);
        });

        dropdown.appendChild(select);
        dropdown.appendChild(label);
        container.appendChild(dropdown);

        select.addEventListener("change", function () {
            while (dropdown.nextSibling) {
                container.removeChild(dropdown.nextSibling);
            }

            const selectedOption = category.options.find(opt => opt.value === select.value);
            if (selectedOption && selectedOption.subcategories.length > 0) {
                createDropdown(
                    { fieldId: selectedOption.fieldId, options: selectedOption.subcategories },
                    container,
                    selectedOption.label
                );
            }
        });
    }

    const form = document.getElementById("support-form");
    form.addEventListener("submit", async function (event) {
        event.preventDefault();
        formMessage.style.display = "none";
        uploadTokens = [];

        const subject = document.getElementById("subject").value;
        const rawDescription = document.getElementById("description").value;
        const description = stripHtmlTags(rawDescription); // Nettoyage de la description
        const orderNumber = document.getElementById("order-number").value;
        const fullName = document.getElementById("name").value;
        const email = document.getElementById("email").value;

        const formData = {
            subject: subject || "Sujet non spécifié",
            description: description || "Description non fournie",
            priority: "normal",
            name: fullName || "API Shopify",
            email: email || "shopify.api@petiscope.fr",
            custom_fields: [],
            uploads: []
        };

        const selects = document.querySelectorAll("#categories select, #dynamic-categories select");
        selects.forEach(select => {
            const fieldId = parseInt(select.dataset.fieldId, 10);
            const value = select.value;
            if (value) {
                formData.custom_fields.push({ id: fieldId, value: value });
            }
        });

        if (orderNumber) {
            formData.custom_fields.push(
                { id: 17796608117532, value: orderNumber },
                { id: 17732062894236, value: orderNumber }
            );
        }

        if (attachmentsInput.files.length > 0) {
            showMessage("Upload des fichiers en cours...", "info");

            try {
                const tokens = await uploadFiles(attachmentsInput.files);
                if (tokens.length > 0) uploadTokens = tokens;
            } catch (error) {
                showMessage("Erreur lors de l'upload des fichiers.", "error");
                return;
            }
        }

        if (uploadTokens.length > 0) {
            formData.uploads = uploadTokens;
        }

        fetch("https://petiscope-contact-form-998c5ae65b30.herokuapp.com/api/create-ticket", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData)
        })
            .then(response => response.json())
            .then(data => {
                showMessage("Votre demande a été envoyée avec succès !", "success");

              // Réinitialiser le formulaire
              form.reset();
              uploadTokens = []; // Réinitialiser les fichiers uploadés
      
              // Réinitialiser les sélections dynamiques
              dynamicCategoriesContainer.innerHTML = "";
      
              // Réinitialiser la catégorie principale
              categorySelect.selectedIndex = 0;
      
              // Effacer les messages d’upload des fichiers
              document.getElementById("upload-status").textContent = "";
      
              // Nettoyer le champ description (si Quill.js est encore utilisé)
              if (typeof quill !== "undefined") {
                  quill.setText(""); // Réinitialiser Quill
              }
      
              // Forcer la suppression des valeurs des selects
              document.querySelectorAll("#dynamic-categories select").forEach(select => {
                  select.selectedIndex = 0;
              });
            })
            .catch(error => {
                showMessage("Une erreur est survenue. Veuillez réessayer.", "error");
            });
    });

    async function uploadFiles(files) {
        const formData = new FormData();
        for (let file of files) {
            formData.append("files", file);
        }

        const response = await fetch("https://petiscope-contact-form-998c5ae65b30.herokuapp.com/api/upload-attachments", {
            method: "POST",
            body: formData
        });

        const data = await response.json();
        return data.tokens || [];
    }

    // **🛠 Fonction pour nettoyer la description des balises HTML**
    function stripHtmlTags(input) {
        return input.replace(/<[^>]*>?/gm, '').trim(); // Supprime toutes les balises HTML
    }

    // **Fonction pour afficher les messages sous le bouton**
    function showMessage(message, type) {
        formMessage.textContent = message;
        formMessage.className = `form-message ${type}`;
        formMessage.style.display = "block";
    }

    function toggleOrderNumberRequirement(selectedCategory) {
      const orderNumberInput = document.getElementById("order-number");
  
      if (selectedCategory === "assistance_générale") {
          orderNumberInput.removeAttribute("required");
      } else {
          orderNumberInput.setAttribute("required", "required");
      }
    }

});
